import React, { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { isArray } from 'lodash';
import parse from 'html-react-parser';

import './styles.scss';

const EmailPreview = ({ formData, onBack }) => {
  const userInfo = useSelector((state) => state.global.userInfo);

  const {
    recipients,
    cc,
    bcc,
    subject,
    message,
    htmlMessage,
    attachments,
  } = formData || {};
  const iframeRef = useRef(null);
  const [htmlMessageStyle, setHtmlMessageStyle] = useState({ width: '100%', height: '400px' });

  const handleHhtmlMessageLoad = () => {
    if (iframeRef.current) {
      const iframe = iframeRef.current;
      const doc = iframe.contentDocument || iframe.contentWindow.document;

      if (doc) {
        const height = doc.body.scrollHeight;

        setHtmlMessageStyle({
          width: '100%',
          height: `${height}px`,
        });
      }
    }
  };

  let recipientsStr = recipients;

  if (isArray(recipients)) {
    recipientsStr = recipients.join(', ');
  }

  let ccStr = cc;

  if (isArray(cc)) {
    ccStr = cc.join(', ');
  }

  let bccStr = bcc;

  if (isArray(bcc)) {
    bccStr = bcc.join(', ');
  }

  const { firstName, lastName } = userInfo;

  return (
    <section className="email_previewer">
      <aside className="email_previewer__header">
        <p
          className="email_title"
          title={userInfo?.email}
        >
          From: {`${firstName} ${lastName}`}
        </p>
        <p className="email_address">To: {recipientsStr}</p>
        {cc.length > 0 && (
          <p className="email_address">Cc: {ccStr}</p>
        )}
        {bcc.length > 0 && (
          <p className="email_address">Bcc: {bccStr}</p>
        )}
        <p className="email_subject">Subject: {subject}</p>
      </aside>
      <section className="email_previewer__content">
        <article className="email_previewer__content_description">
          {htmlMessage ? (
            <iframe
              ref={iframeRef}
              srcDoc={htmlMessage}
              onLoad={handleHhtmlMessageLoad}
              style={{
                ...htmlMessageStyle,
                border: 'none',
              }}
              title="Email Preview"
            />
          ) : (
            <div // TODO: This is a placeholder
              className="message_preview"
            >
              {parse(message)}
            </div>
          )}
        </article>
      </section>
      {attachments.length > 0 && (
        <div className="email_previewer__attachments">
          <div className="email_previewer__attachments-title">Attachment(s)</div>
          {attachments.map(file => (
            <div
              key={file.id}
              className="email_previewer__attachments-file"
            >
              {file.filename}
            </div>
          ))}
        </div>
      )}
      <div className="email_previewer__footer">
        <button
          type="button"
          className="button"
          onClick={onBack}
        >
          Back To Editor
        </button>
      </div>
    </section>
  );
};

EmailPreview.propTypes = {
  formData: PropTypes.object,
  onBack: PropTypes.func,
};

export default EmailPreview;
